// extracted by mini-css-extract-plugin
var _1 = "Button-moduleblock__C2vDP";
var _2 = "Button-modulebutton__AisLs";
var _3 = "Button-modulecircle__WR9YS";
var _4 = "Button-moduleiconBig__DkKpE";
var _5 = "Button-moduleiconSmall__OJ9jT";
var _6 = "Button-moduleinert__mKdtD";
var _7 = "Button-moduleinline__Zsuj4";
var _8 = "Button-moduleinlineSize16__u489K";
var _9 = "Button-moduleinlineSize24__q_Ic1";
var _a = "Button-moduleshadowed___eDn3";
var _b = "Button-modulesize20__Iqv1S";
var _c = "Button-modulesize24__Yb94W";
var _d = "Button-modulesize32__z2lWQ";
var _e = "Button-modulesize40__JUDky";
var _f = "Button-modulesize48__J1V7k";
var _10 = "Button-moduleskeleton__hkdVU";
var _11 = "Button-modulesquareSize16__XX9c5";
var _12 = "Button-modulesquareSize20__pqw9N";
var _13 = "Button-modulesquareSize24__El9LU";
var _14 = "Button-modulesquareSize32__YE0pv";
var _15 = "Button-modulesquareSize40__Sti9Y";
var _16 = "Button-modulesquareSize48__rV8dp";
var _17 = "Button-moduletext__fXCJk";
var _18 = "Button-modulewithIcon__xPZYQ";
export { _1 as "block", _2 as "button", _3 as "circle", _4 as "iconBig", _5 as "iconSmall", _6 as "inert", _7 as "inline", _8 as "inlineSize16", _9 as "inlineSize24", _a as "shadowed", _b as "size20", _c as "size24", _d as "size32", _e as "size40", _f as "size48", _10 as "skeleton", _11 as "squareSize16", _12 as "squareSize20", _13 as "squareSize24", _14 as "squareSize32", _15 as "squareSize40", _16 as "squareSize48", _17 as "text", _18 as "withIcon" }
